import React, { Fragment } from "react";

import { twMerge } from "tailwind-merge";

import { Tooltip } from "src/design-system/Tooltip";

type Props = {
  children?: React.ReactNode;
  className?: string;
  dataLoc?: string;
  withTooltip?: boolean;
};

export const IntermediateResultsHeaderCell: React.FC<Props> = ({
  children,
  className,
  withTooltip = false,
  dataLoc,
}) => {
  const tooltipWrapper = ({
    children: trigger,
  }: {
    children: React.ReactNode;
  }) => (
    <Tooltip placement="top" title={children} asChild>
      {trigger}
    </Tooltip>
  );
  const Wrapper = withTooltip ? tooltipWrapper : Fragment;

  return (
    <Wrapper>
      <div
        className={twMerge(
          "overflow-hidden text-ellipsis py-1.5 pr-4 pl-2 text-left font-inter-medium-12px text-gray-800",
          className,
        )}
        data-loc={dataLoc}
      >
        {children}
      </div>
    </Wrapper>
  );
};
